import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
let ZendeskSupportMixin = class ZendeskSupportMixin extends Vue {
    get pagesWithZendeskSupport() {
        return ['/login', '/diy', '/apps', '/affiliate'];
    }
    routePathObserver(path) {
        const id = 'ze-snippet';
        const el = document.getElementById('launcher');
        if (this.routeInZendeskWhitelist(path) && el) {
            const zendeskSupport = document.createElement('script');
            zendeskSupport.setAttribute('id', id);
            zendeskSupport.setAttribute('src', 'https://static.zdassets.com/ekr/snippet.js?key=264b7adb-b65e-4eae-a84d-030a60914cce');
            document.body.appendChild(zendeskSupport);
            el.style.display = 'block';
        }
        else if (!this.routeInZendeskWhitelist(path) && document.getElementById(id) && el) {
            document.getElementById(id).remove();
            el.style.display = 'none';
        }
    }
    routeInZendeskWhitelist(path) {
        return this.pagesWithZendeskSupport.some((pathSlug) => path.includes(pathSlug));
    }
};
__decorate([
    Watch('$route.path', { immediate: true })
], ZendeskSupportMixin.prototype, "routePathObserver", null);
ZendeskSupportMixin = __decorate([
    Component
], ZendeskSupportMixin);
export default ZendeskSupportMixin;
